import classes from './SignupSection.module.scss';

export default function SignupSection({
  isSignup,
  isTouched,
  setIsSignup,
  setIsTouched,
  t,
  language,
}) {
  const titleClasses = `${classes.title} ${classes['title-' + language]}`;

  const sectionClass = () => {
    if (isTouched) {
      return isSignup ? classes.animationUp : classes.animationDown;
    }
    return isSignup ? classes.signupState : classes.loginState;
  };

  return (
    <div className={`${classes.signupSection} ${sectionClass()}`}>
      <p
        className={titleClasses}
        onClick={() => {
          if (!isSignup) {
            setIsSignup(true);
            setIsTouched(true);
          }
        }}
      >
        {t('signup')}
      </p>
    </div>
  );
}
